import {useState, useEffect} from "react";
import {fetchInitiativeByIdData} from "../helper/requests";
import {urlApiDataCRGCI, apiKeyDataCRGCI} from "../helper/api";
import {
  IInitiativeApiResponse,
  IInitiativeApiSingleResponse,
} from "../pages/StateInitiative/StateInitiative.type";

const useFetchDataStateInitiativeById = (documentId: string | null) => {
  const [initiativeData, setInitiativeData] =
    useState<IInitiativeApiResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!documentId) {
      setInitiativeData(null);
      setLoading(false);
      setError(null);
      return;
    }

    if (!urlApiDataCRGCI || !apiKeyDataCRGCI) {
      setError(new Error("CRGCI API URL или ключ не настроены"));
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response: IInitiativeApiSingleResponse | null =
          await fetchInitiativeByIdData(
            urlApiDataCRGCI,
            apiKeyDataCRGCI,
            documentId
          );

        if (response && response.data && response.data.length > 0) {
          const initiative = response.data[0];

          setInitiativeData(initiative);
        } else {
          setInitiativeData(null);
        }
      } catch (err) {
        console.error("Error fetching initiative data:", err);
        setError(err instanceof Error ? err : new Error("Неизвестная ошибка"));
        setInitiativeData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [documentId]);

  return {
    initiativeData,
    loading,
    error,
  };
};

export default useFetchDataStateInitiativeById;
